import request from '@/utils/request'

/**
 * 获取仓库库存列表
 * @param {*} data
 * @returns
 */
export const getCKKcList = (data) => request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/ckkc/list",
    data: data
})

/**
 * 获取仓库库存
 * @param {*} id
 * @param {*} data
 * @returns
 */
 export const getCkkc = (id, data) => request({
    method: 'get',
    url: `/yzdservice/enterprise/dwCk/ckkc/detail/${id}`,
    data: data
})

/**
 * 导出
 * @param {*} data
 * @returns
 */
export const excelwriter = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/ckkc/excelwriter`,
    data:data,
    responseType: 'blob'
})

